import { useRef } from "react"

export const useElemRef = <T = HTMLDivElement>() => useRef<T | null>(null)
